// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CardTickIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CardTick/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.667 9.55v4.167a3.446 3.446 0 0 0 3.45 3.45h9.758a3.46 3.46 0 0 0 3.458-3.459V9.55c0-.558-.45-1.008-1.008-1.008H2.675c-.558 0-1.008.45-1.008 1.008Zm5 4.825H5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h1.667a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Zm5.416 0H8.75a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h3.333a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625ZM11.25 3.842v2.441c0 .559-.45 1.009-1.008 1.009H2.675a1.015 1.015 0 0 1-1.008-1.025c.008-.942.383-1.8 1.008-2.425a3.446 3.446 0 0 1 2.442-1.009h5.125c.558 0 1.008.45 1.008 1.009ZM16.642 1.667h-2.45c-1.059 0-1.692.633-1.692 1.691v2.45c0 1.059.633 1.692 1.692 1.692h2.45c1.058 0 1.691-.633 1.691-1.692v-2.45c0-1.058-.633-1.691-1.691-1.691Zm.55 2.041-1.975 2.309a.408.408 0 0 1-.309.15h-.016a.428.428 0 0 1-.309-.125l-.916-.9a.433.433 0 0 1 0-.609.425.425 0 0 1 .608 0l.583.575 1.667-1.95a.434.434 0 0 1 .608-.05c.192.15.209.425.059.6Z"
}));
export default CardTickIcon;